import { createContext } from 'react';
import { connect } from 'getstream';

type Client = ReturnType<typeof connect>

type StreamContext = {
  token: string,
  client: Client | null,
}

const defaultContext: StreamContext = {
  token: '',
  client: null,
}

export default createContext(defaultContext);
